import {crud} from "../../../crudRequests";

// What each profile tab edits. A tab saves its own fields and nothing else:
// sending the whole record back rewrote fields the patient never saw — the
// clinicians assigned to them, their payment customer ids, whether they may
// start a chat — with whatever copy the browser held.
export const MEDICAL_FIELDS = [
  "medications",
  "allergies",
  "preDiagnosedMedicalConditions",
  "preDiagnosedMentalHealthDisorders",
  "familyHealthProblems",
  "preferredPharmacy",
];

export const INSURANCE_FIELDS = ["healthCard", "tpp"];

export const SOCIAL_FIELDS = [
  "occupation",
  "employerName",
  "economicStatus",
  "educationLevel",
  "tobacco",
  "alcohol",
  "caffeine",
  "cannabis",
  "maritalStatus",
  "sexualOrientation",
  "exerciseFrequency",
  "dietaryRestrictions",
  "psychedelics",
  "hardDrugs",
  "military",
  "disability",
];

export async function updatePatient({patientData, fields, state}) {
  const changes = {};
  for (const field of fields) {
    if (field in patientData) changes[field] = patientData[field];
  }
  return await crud(state, [
    {
      db: state.db,
      collection: "patients",
      parameters: [{pid: patientData.pid}, {$set: changes}],
      method: "updateOne",
    },
  ]);
}
